import Qs from "qs";

/**
 * Set the selected value in the URL. If it's already selected, clear it.
 * @param queryParameter       Name of the URL parameter.
 * @param queryParameterPrefix Optional prefix for the query parameter name.
 * @param search               Current query search string.
 * @param value                Selected value.
 * @returns                    Updated URL.
 */
export const updateUrl = (
    queryParameter: string,
    queryParameterPrefix: string | undefined,
    search: string,
    value: any
) => {
    const current = Qs.parse(search, { ignoreQueryPrefix: true });
    const parameterName = getParameterName(queryParameter, queryParameterPrefix);
    const { [parameterName]: currentValue, ...otherParameters } = current;

    // When the user clicks an already selected value it should be removed instead.
    const isSameValue = currentValue === String(value);
    const parameters = isSameValue ? otherParameters : { ...current, [parameterName]: value };
    return { search: Qs.stringify(parameters, { addQueryPrefix: true }) };
};

/**
 * Maybe combine the query parameter with a prefix.
 * @param queryParameterPrefix Optional prefix for the parameter.
 * @param queryParameter       Name of the parameter.
 * @returns                    Combined prefix and name.
 */
const getParameterName = (queryParameter: string, queryParameterPrefix: string | undefined) => {
    return typeof queryParameterPrefix === "string" ? `${queryParameterPrefix}.${queryParameter}` : queryParameter;
};
